import type { ReportFilters, ReportType } from '@/lib/api/reports/reports-api'
import type { ReportConfig } from './report-configs'
import { BILLING_STATUS_NONE } from './report-configs'

/**
 * Onde o padrão de status da cobrança (`lib/billing/default-billing-status.ts`) entra,
 * relatório a relatório.
 */

export {
    DEFAULT_BILLING_STATUS_KEY,
    NO_DEFAULT_BILLING_STATUS,
    defaultBillingStatusFilter,
    readDefaultBillingStatus,
    saveDefaultBillingStatus,
} from '@/lib/billing/default-billing-status'

/** O relatório oferece o filtro "Status da Cobrança"? Só nesses o padrão se aplica. */
export function supportsBillingStatus(config?: ReportConfig | null): boolean {
    return !!config?.extraFilters?.some(filter => filter.key === 'billingStatus')
}

/**
 * O padrão aplicado ao filtro certo de cada tipo. São dois campos diferentes para a
 * mesma pergunta ("como está a cobrança?"):
 *
 * - **`billingStatus`** nos relatórios de atendimento e venda (consulta, exame,
 *   procedimento, negócio, funil): a cobrança é um satélite da linha.
 * - **`status`** em Lançamentos, onde a cobrança **é** a linha. Os valores são os
 *   mesmos (`BILLING_STATUS_LABELS`), então ignorar essa aba faria o operador escolher
 *   "Pago" no topo e continuar remarcando à mão justamente onde o filtro é mais usado.
 *
 * "Sem cobrança" fica de fora de Lançamentos: ali toda linha é uma cobrança, e o
 * recorte não existe.
 */
export function defaultBillingStatusPatch(
    reportType: ReportType,
    config: ReportConfig | undefined,
    value: string,
): Partial<ReportFilters> {
    if (!value) return {}

    if (reportType === 'billings') {
        return value === BILLING_STATUS_NONE ? {} : { status: [value] }
    }

    return supportsBillingStatus(config) ? { billingStatus: [value] } : {}
}
